export const API_URL = process.env.VUE_APP_BASE_URL;

export const SERVICE_API_URL = "/api/v3/client";

export const VERSION = 2;
export const VERSION_CODE = "1.0.2";
